import { Box, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { decode } from "html-entities";
import { IAttribute, IAttributeGroups, IOfferzProductTabs } from "@/types/product";

interface ProductsTabsProps {
  offerzProductTabs: IOfferzProductTabs[];
}

const ProductTabs: React.FC<ProductsTabsProps> = ({ offerzProductTabs }) => {
  const [openTabs, setOpenTabs] = useState<{ [key: number]: boolean }>(() => {
    const initialOpenTabs: { [key: number]: boolean } = { 0: true };

    offerzProductTabs.forEach((tab, index) => {
      if (tab.view_required === 1) {
        initialOpenTabs[index] = true;
      }
    });

    return initialOpenTabs;
  });

  const handleToggle = (index: number) => {
    setOpenTabs((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <Box sx={{ mt: "50px", borderBottom: "1px solid #eee" }}>
      {offerzProductTabs.map(
        (tab, index) =>
          (tab.text.length > 0 || tab?.attribute_groups?.length > 0) && (
            <Box key={index} sx={{ borderTop: "1px solid #eee", py: 2 }}>
              <Box
                onClick={() => handleToggle(index)}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <Typography sx={{ fontSize: "18px", fontWeight: 600 }}>{tab.name}</Typography>
                <IconButton
                  disableRipple
                  sx={{
                    transform: openTabs[index] ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s",
                    "&:hover": {
                      bgcolor: "transparent",
                    },
                  }}
                >
                  <ExpandMoreIcon />
                </IconButton>
              </Box>

              {openTabs[index] && (
                <Box
                  sx={{
                    pt: 1,
                  }}
                >
                  {tab.text.length > 0 && (
                    <Box
                      sx={{
                        "& ul": {
                          listStyleType: "disc",
                          marginLeft: "1.5em",
                        },
                        "& ol": {
                          listStyleType: "decimal",
                          marginLeft: "1.5em",
                        },
                        "& li": {
                          marginBottom: "0.5em",
                        },
                      }}
                    >
                      <Box
                        className="admin"
                        dangerouslySetInnerHTML={{ __html: decode(tab?.text) }}
                      />
                    </Box>
                  )}

                  {tab?.attribute_groups?.length > 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                        pt: 1,
                      }}
                    >
                      {tab?.attribute_groups?.map(
                        (attribute: IAttributeGroups, attrIndex: number) => (
                          <Box key={attrIndex} sx={{ display: "flex", flexDirection: "column" }}>
                            <Typography variant="body1" sx={{ mb: 2, fontWeight: 600 }}>
                              {attribute.name}
                            </Typography>

                            {attribute?.attribute.map(
                              (singleAttr: IAttribute, singleAttrIndex: number) => (
                                <Box
                                  key={singleAttrIndex}
                                  sx={{
                                    display: "flex",
                                    mb: 1,
                                    pb: 1,
                                    gap: 1,
                                    borderBottom:
                                      singleAttrIndex < attribute?.attribute.length - 1
                                        ? "1px solid #eee"
                                        : "",
                                  }}
                                >
                                  <Typography variant="body2" sx={{ width: "50%" }}>
                                    {singleAttr.name}
                                  </Typography>
                                  <Typography variant="body2" color="#777" sx={{ width: "50%" }}>
                                    {singleAttr.text}
                                  </Typography>
                                </Box>
                              ),
                            )}
                          </Box>
                        ),
                      )}
                    </Box>
                  )}
                </Box>
              )}
            </Box>
          ),
      )}
    </Box>
  );
};

export default React.memo(ProductTabs);
